import { TopBar } from "../common/TopBar";
import { useState } from "react";
import { LoginService } from "@propertelligent/client-api";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import "./ResetPassword.css";
import apiHelper from "../../utils/apiHelper";
import CustomInputs from "../common/Inputs";
import AddButtonWithArrow from "../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { useError } from "../../utils/context/ErrorContext";
import { checkEmptyFieldsFunc, validatePassword } from "../../utils/validateHelper";

const ResetPassword = () => {
  const { userKey } = useParams();
  const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } = useError()
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const navigate = useNavigate();
const setPassword = (e) => {
  e.preventDefault();
  if (newPassword !== confirmPassword) {
    setErrors({ ...errors, confirmPassword: true });
    setErrorMessages({ ...errorMessages, confirmPassword: "Passwords must match" });
    return; 
  }

  const payload = { guid: userKey, password: newPassword };
  validatePassword(newPassword, setErrors, setErrorMessages);
  if (checkEmptyFieldsFunc(payload, clearErrors, errors, errorMessages, setErrors, setErrorMessages, undefined)) {
    return; 
  } else {
    apiHelper(LoginService.postApiLoginSetPassword, {
      successMessage: "Successfully Reset Password",
      failureMessage: "Error Resetting Password",
      showNotification: true,
    }, payload)
    .then((res) => {
      if (res?.data?.success) {
        setTimeout(() => { navigate("/login"); }, 3000);
      }
    })
    .catch((error) => {
    });
  }
};
  return (
    <>
      <div className="background-section background-image" >
        <div className="reset-pass-container">
          <TopBar haveAccount="Don’t have an account?" signInUp="Sign up" />
          <div className="form-container-main">
            <form className="form-container" onSubmit={setPassword} >
              <p className="top_header mb-4 black">Reset password</p>
              <div className="input-container">
                <CustomInputs
                  myClassName="input-field normal_text"
                  labelText="New password"
                  type={showNewPassword ? "text" : "password"}
                  placeholder="New password"
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setErrors((prevErrors) => ({ ...prevErrors, "password": false }));
                    setErrorMessages((prevMessages) => ({ ...prevMessages, "password": "" }));
                  }}
                   onBlur={() => {validatePassword(newPassword, setErrors, setErrorMessages)
                   
                   }}
                  required
                  isPassword={true}
                  isError={errors?.password}
                  errorMessages={errorMessages?.password}
                />
              </div>
              <div className="confirm-password-container">
                <div className="input-container">
                  <CustomInputs
                    labelText="Re-enter new password"
                    myClassName="input-field normal_text"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Re-enter new password"
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setErrors((prevErrors) => ({ ...prevErrors, "confirmPassword": false }));
                      setErrorMessages((prevMessages) => ({ ...prevMessages, "confirmPassword": "" }));
                    }}
                    onBlur={() => {
                      if (newPassword !== confirmPassword) {
                        setErrors({ ...errors, confirmPassword: true })
                        setErrorMessages({ ...errorMessages, confirmPassword: "confirm Password must be match with password" })
                      } else {
                        setErrors({ ...errors, confirmPassword: false })
                        setErrorMessages({ ...errorMessages, confirmPassword: "" })
                      }
                    }}
                    required
                    isPassword={true}
                    isError={errors?.confirmPassword}
                    errorMessages={errorMessages?.confirmPassword}
                  />

                </div>

              </div>
              <AddButtonWithArrow
                type="submit"
                buttonname="Reset Password"

                className="w-100"
              />
            </form>

          </div>

        </div>
      </div>
    </>
  );
};

export default ResetPassword;
